import {
  PixlSupermodelsResponse,
  PostApiPixlSupermodelsImagesBody
} from '@spo/types';
import { apiBff } from '.';

export const getImages = async (
  postApiPixlSupermodelsImagesBody: PostApiPixlSupermodelsImagesBody,
): Promise<PixlSupermodelsResponse> =>
  apiBff.callBFF(
    'POST',
    'images/supermodels',
    postApiPixlSupermodelsImagesBody,
  );